<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <a-form layout="vertical" >
          
          <a-form-item
            label="切片大小"
          > <span style="margin:0px 10px 0 10px">行</span> 
            <a-input-number :min="32"  :defaultValue="sliceHeight" @change="onChangeSliceHeight" />
            <span style="margin:0px 10px 0 10px">px</span> 
            <span style="margin:0px 10px 0 0px">X</span> 
            <span style="margin:0px 10px 0 0px">列</span> 
            <a-input-number :min="32"  :defaultValue="sliceWidth" @change="onChangeSliceWidth" />
            <span style="margin:0px 10px 0 10px">px</span>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handleSave">保存</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { editItem } from '@/api/item'

export default {
  name: 'NDPIsetting',
  data () {
    return {
      sliceHeight: 0,
      sliceWidth: 0,
    }
  },
  created () {
    this.sliceHeight = this.$store.getters.projectData.sliceHeight || 0
    this.sliceWidth = this.$store.getters.projectData.sliceWidth || 0
  },
  methods: {
    handleSave () {
      const _this = this
      const label_type = this.label_type
      editItem({
        item_id: _this.$store.getters.projectId,
        slice_height: _this.sliceHeight,
        slice_width: _this.sliceWidth,
      }).then(res => {
        if (res.code != 200) {
          _this.$message.error('保存失败')
          return
        }
        _this.$message.success('保存成功')
        _this.$store.dispatch('UpdateProjectData', { sliceHeight: _this.sliceHeight })
        _this.$store.dispatch('UpdateProjectData', { sliceWidth: _this.sliceWidth })
      }).catch(() => {
        _this.$message.error('保存失败')
      })
    },
    onChangeSliceHeight(val){
      this.sliceHeight = val
    },
    onChangeSliceWidth(val){
      this.sliceWidth = val
    },
  
  }
}
</script>
